function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import ExecutionEnvironment from 'exenv';
import PropTypes from 'prop-types'; // Import the light version of Lottie that only
// supports the SVG renderer.
// https://github.com/airbnb/lottie-web/wiki/Bodymovin-Light

var lottie = null;

if (ExecutionEnvironment.canUseDOM) {
  lottie = require('lottie-web/build/player/lottie_light.min');
}

var DOMAnimation = /*#__PURE__*/function (_PureComponent) {
  _inherits(DOMAnimation, _PureComponent);

  var _super = _createSuper(DOMAnimation);

  function DOMAnimation() {
    _classCallCheck(this, DOMAnimation);

    return _super.apply(this, arguments);
  }

  _createClass(DOMAnimation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.animation = lottie.loadAnimation(_objectSpread(_objectSpread({}, this.props.options), {}, {
        wrapper: this.wrapper,
        renderer: 'svg'
      }));

      if (this.props.speed || this.props.speed === 0) {
        this.animation.setSpeed(this.props.speed);
      }

      if (this.props.onAnimationEnd) {
        this.animation.onComplete = this.props.onAnimationEnd;
      }

      if (this.props.onAnimationLoopEnd) {
        this.animation.onLoopComplete = this.props.onAnimationLoopEnd;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.animation.destroy();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isStopped || this.props.isPaused) {
        if (this.props.isStopped) {
          this.animation.stop();
        } else {
          this.animation.pause();
        }
      } else {
        this.animation.play();
      }

      this.animation.setSpeed(this.props.speed);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var styles = {
        width: "".concat(this.props.width, "px"),
        height: "".concat(this.props.height, "px"),
        overflow: 'hidden',
        margin: '0 auto'
      };
      return /*#__PURE__*/React.createElement("div", {
        style: styles,
        ref: function ref(el) {
          _this.wrapper = el;
        }
      });
    }
  }]);

  return DOMAnimation;
}(PureComponent);

DOMAnimation.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.shape({
    loop: PropTypes.bool,
    autoPlay: PropTypes.bool,
    animationData: PropTypes.object.isRequired,
    rendererSettings: PropTypes.object
  }),
  isStopped: PropTypes.bool,
  isPaused: PropTypes.bool,
  speed: PropTypes.number,
  onAnimationEnd: PropTypes.func,
  onAnimationLoopEnd: PropTypes.func
};
DOMAnimation.defaultProps = {
  width: '100%',
  height: '100%',
  isStopped: false,
  isPaused: false,
  speed: 1
};

var Animation = function Animation(props) {
  if (lottie) {
    return /*#__PURE__*/React.createElement(DOMAnimation, props);
  }

  return null;
};

Animation.propTypes = DOMAnimation.propTypes;
Animation.defaultProps = DOMAnimation.defaultProps;
export default Animation;